export default "__VITE_ASSET__DNWF_s66__"